import { render, staticRenderFns } from "./KitSummary.vue?vue&type=template&id=e37b1ae2"
import script from "./KitSummary.vue?vue&type=script&lang=ts"
export * from "./KitSummary.vue?vue&type=script&lang=ts"
import style0 from "./KitSummary.vue?vue&type=style&index=0&id=e37b1ae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports